export default __webpack_public_path__ + "3bfd8093e9169268b628e39942692d3e.glb";